<template>
  <v-hover v-slot="{ hover }">
    <v-card
      width="100%"
      height="100%"
      elevation="0"
      :class="{ 'on-hover': hover }"
    >
      <v-img
        v-if="isShowImage"
        width="100%"
        height="100%"
        class="ma-0"
        contain
        :src="mediaUrl"
        :lazy-src="mediaUrl"
        @error="imageLoadingError"
      />

      <div
        v-else
        class="pa-4"
      >
        <v-img
          width="100%"
          height="100%"
          class="ma-0 "
          contain
          :src="require('@/assets/images/general/icon_default_img.svg')"
        />
      </div>

      <div class="action-btn-group d-flex justify-center">
        <div
          class="action-btn d-flex justify-center align-center"
        >
          <div
            class="action-btn-icon"
            :class="{ 'show-btn': hover }"
            @click="openVideo"
          >
            <v-icon
              color="neutral-047"
              size="32"
            >
              $vuetify.icons.enlargeIcon
            </v-icon>
          </div>
        </div>
        <div
          class="action-btn d-flex justify-center align-center"
        >
          <div
            class="action-btn-icon"
            :class="{ 'show-btn': hover }"
            @click="changePhoto($event)"
          >
            <v-icon
              color="neutral-047"
              size="32"
            >
              $vuetify.icons.cameraIcon
            </v-icon>
          </div>
        </div>
        <div
          class="action-btn d-flex justify-center align-center"
        >
          <div
            class="action-btn-icon"
            :class="{ 'show-btn': hover }"
            @click="deletePhoto($event)"
          >
            <v-icon
              color="neutral-047"
              size="32"
            >
              $vuetify.icons.trashCanIcon
            </v-icon>
          </div>
        </div>
      </div>
      <v-file-input
        v-model="files"
        type="file"
        ref="file"
        class="d-none"
        @change="onFileChanged"
        accept=".png, .jpeg, .jpg, .mp4"
      />
      <Notification
        ref="notification"
      />
    </v-card>
  </v-hover>
</template>

<script>
import { mapState } from 'vuex';
import { getThumbnailForVideo, base64ToBlob } from '@/utils';
import uploadApi from '../../../restapis/upload';

export default {
  name: 'ImagePreview',
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    mediaUrl: {
      type: String,
      default: ''
    },
    imageSize: {
      type: Number,
      default: 5
      // 單位為 MB
    },
    videoSize: {
      type: Number,
      default: 16
      // 單位為 MB
    }
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    })
  },
  data() {
    return {
      isLoading: false,
      isShowImage: true,
      // imageUrl: '',
      files: { name: this.mediaUrl } || {}
    };
  },

  methods: {
    deletePhoto() {
      this.$emit('delete-media');
    },
    openVideo() {
      window.open(this.mediaUrl, '_blank');
    },
    changePhoto(e) {
      e.stopPropagation();
      this.onUpload();
    },
    onUpload() {
      this.$refs.file.$refs.input.click();
    },
    async onFileChanged(event) {
      console.log('onFileChanged');
      let mediaType = 'image';
      try {
        let file = null;
        if (event.dataTransfer) {
          file = event.dataTransfer.files[0];
        } else {
          file = event;
        }
        // Check file type
        if (!['png', 'jpg', 'jpeg', 'mp4'].includes(file.type.slice(6))) {
          const notificationObj = {
            title: this.$t('DEFAULT_REPLY.MEDIA_TYPE_MUST_BE'),
            status: 'error'
          };
          this.$refs.notification.openNotification(notificationObj);
          return;
        }

        if (['png', 'jpg', 'jpeg'].includes(file.type.slice(6))) {
          mediaType = 'image';
        } else {
          mediaType = 'video';
        }

        // Check file size
        const upperLimitFileSize = mediaType === 'image' ? this.imageSize : this.videoSize;
        if (this.checkFileSize(file.size, mediaType)) {
          const notificationObj = {
            title: `${this.$t('STICKER_PACK.FILE_SIZE_MUST_BE_LESS_THAN')} ${upperLimitFileSize} MB`
          };
          this.$refs.notification.openNotification(notificationObj);
          return;
        }

        this.isLoading = true;
        const blob = new Blob([file], { type: file.type });

        let uploadData = null;
        let previewUrl = '';
        if (mediaType === 'image') {
          uploadData = await uploadApi.postPhoto({
            photo: blob,
            team: this.currentUserDict.team
          });
        } else {
          const fileUrl = URL.createObjectURL(file);
          const thumbUrl = await getThumbnailForVideo(fileUrl);

          const thumbBlob = base64ToBlob(thumbUrl);
          const uploadThumbnailData = await uploadApi.postPhoto({
            photo: thumbBlob,
            team: this.currentUserDict.team
          });
          previewUrl = uploadThumbnailData.data.path;

          uploadData = await uploadApi.postMedia({
            media: blob,
            team: this.currentUserDict.team,
            platform: 'line',
            type: 11
          });
        }

        this.files = { name: uploadData.data.path };
        this.$emit('update-media', { mediaType: mediaType, url: uploadData.data.path, previewUrl: previewUrl });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        const notificationObj = {
          title: this.$t('FAILED_TO_UPLOAD_FILE')
        };
        this.$refs.notification.openNotification(notificationObj);
      }
    },
    checkFileSize(fileSize, upperLimitFileSize) {
      return fileSize > (1024 * 1024) * upperLimitFileSize;
    },
    imageLoadingError() {
      this.isShowImage = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.drag-wrapper{
  width: 100%;
  height: 100%;
}

.v-card {
  position: relative;
  width: 100%;
  height: 100%;
  &::after {
    opacity: 1;
    transition: opacity .3s ease-in-out;
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
}

.v-card:not(.on-hover) {
   &::after {
    opacity: 0;
   }

}

.action-btn-group {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  top: 0;
  > *:not(:last-child) {
    margin-right: 25px;
  }
  .action-btn {
    .action-btn-icon {
      transition: all 0.5s;
      opacity: 0;
      display: block;
      &.show-btn {
        opacity: 1;
      }
    }
  }
  .action-btn:hover {
    cursor: pointer;
  }
  // .action-btn {
  //   flex: 0 0 50%;
  // }
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

</style>
